var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopListOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.06 360.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2, .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5, .cls-3 {\n        fill: #a3a3a3;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 259.56,
    y: 20.32,
    width: 238.92,
    height: 335.94
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 368.45,
    y1: 378.28,
    x2: 368.45,
    y2: 239.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f6f6f6",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ddd",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c8c8c8",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#b8b8b8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#acacac",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a5a5a5",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a3a3a3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 88.7,
    width: 150.49,
    height: 9.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 105.91,
    width: 190.23,
    height: 5.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 113.87,
    width: 90.21,
    height: 5.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 133.23,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 134.69,
    width: 42.09,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.03,
    y: 134.69,
    width: 101.06,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 145.42,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 146.89,
    width: 35.25,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.23,
    y: 146.89,
    width: 118.96,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 157.62,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 159.09,
    width: 40.69,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 92.6,
    y: 159.09,
    width: 102.48,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 169.82,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 171.29,
    width: 31.61,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 83.84,
    y: 171.29,
    width: 92.51,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 182.02,
    width: 8.6,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.13,
    y: 183.49,
    width: 38.11,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 89.87,
    y: 183.49,
    width: 113.63,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 194.22,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 195.68,
    width: 35.25,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.23,
    y: 195.68,
    width: 101.06,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 206.42,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 207.88,
    width: 42.09,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.03,
    y: 207.88,
    width: 101.06,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 218.61,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 220.08,
    width: 29.78,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 81.67,
    y: 220.08,
    width: 83.55,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 230.81,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 232.28,
    width: 52.24,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 104.4,
    y: 232.28,
    width: 99.72,
    height: 5.98
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.75,
    y: 243.01,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.51,
    y: 244.48,
    width: 32.38,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.39,
    y: 244.48,
    width: 103.89,
    height: 5.98
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 27.23,
    width: 126.28,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 41.67,
    width: 159.62,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 48.35,
    width: 157.21,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 55.03,
    width: 75.7,
    height: 4.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 299.21,
    y: 88.58,
    width: 138.48,
    height: 75.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 171.49,
    width: 159.62,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 178.17,
    width: 157.21,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 184.85,
    width: 155.98,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 191.52,
    width: 75.7,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 203.01,
    width: 157.21,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 209.68,
    width: 159.62,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 216.36,
    width: 152.13,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 223.03,
    width: 157.21,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 229.71,
    width: 92.56,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 67.68,
    width: 9.33,
    height: 9.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 311.84,
    y: 69.17,
    width: 44.57,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 311.84,
    y: 77.89,
    width: 85.08,
    height: 5.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 299.21,
    y: 266.35,
    width: 138.48,
    height: 75.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.21,
    y: 245.45,
    width: 9.33,
    height: 9.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 311.84,
    y: 246.95,
    width: 44.57,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 311.84,
    y: 255.66,
    width: 85.08,
    height: 5.02
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.97,149.46c-16.42,0-29.74,13.31-29.74,29.74s13.31,29.74,29.74,29.74,29.74-13.31,29.74-29.74-13.31-29.74-29.74-29.74Zm18.86,31.83h-16.77v16.77h-4.18v-16.77h-16.77v-4.18h16.77v-16.77h4.18v16.77h16.77v4.18Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopListOverview);
export default __webpack_public_path__ + "static/media/top_list_overview.55765cfba1bd06342319e8307cf386dd.svg";
export { ForwardRef as ReactComponent };